<template>
  <div id="app"><RouterView /></div>
</template>

<script>
export default {
  name: 'App',
};
</script>

<style lang="scss">
@import '@/scss/main.scss';
</style>
